import { httpClient } from '@/modules/common/services/http/http-client';
import { IPixInfo } from './types';

export const bff = httpClient.withOptions({
  baseURL: process.env.VUE_APP_BFF_URL
});

export function getPixInfo(): Promise<IPixInfo> {
  return bff.get(`/transactions/v1/pix/info`);
}
